import { useState } from 'react'
import './App.css'
import RoadmapAgent from './components/RoadmapAgent'

function App() {
    // Navigation par onglets
    const [activeTab, setActiveTab] = useState('webhook') // 'webhook' | 'roadmap'

    // Machine à états : idle → loading → success/error → idle
    const [status, setStatus] = useState('idle') // 'idle' | 'loading' | 'success' | 'error'
    const [responseData, setResponseData] = useState(null) // Données retournées par n8n
    const [errorMessage, setErrorMessage] = useState('') // Message d'erreur détaillé

    // Fonction principale : déclencher le webhook n8n
    const handleTriggerWorkflow = async () => {
        // 1. Passer en mode chargement
        setStatus('loading')
        setErrorMessage('')
        setResponseData(null)

        // 2. Récupérer l'URL du webhook depuis les variables d'environnement
        // ⚠️ Vite expose uniquement les variables préfixées par VITE_
        const webhookUrl = import.meta.env.VITE_N8N_WEBHOOK_URL

        // 3. Vérifier que l'URL est bien définie
        if (!webhookUrl) {
            setStatus('error')
            setErrorMessage('❌ Variable VITE_N8N_WEBHOOK_URL non définie. Vérifie ton fichier .env')
            return
        }

        // 4. Préparer les données à envoyer (payload JSON)
        const payload = {
            action: 'trigger',
            timestamp: Date.now(),
            source: 'react-frontend'
        }

        try {
            // 5. Envoyer la requête POST au webhook n8n
            const response = await fetch(webhookUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })

            // 6. Vérifier le status HTTP
            if (!response.ok) {
                // Status 4xx ou 5xx
                throw new Error(`Erreur HTTP ${response.status}: ${response.statusText}`)
            }

            // 7. Parser la réponse JSON
            const data = await response.json()

            // 8. Succès : mettre à jour l'état
            setStatus('success')
            setResponseData(data)

        } catch (error) {
            // 9. Gestion des erreurs réseau ou parsing JSON
            setStatus('error')

            // Message d'erreur détaillé selon le type d'erreur
            if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
                setErrorMessage('🌐 Erreur réseau : impossible de joindre le webhook. Vérifie CORS et HTTPS.')
            } else {
                setErrorMessage(`⚠️ ${error.message}`)
            }
        }
    }

    // Fonction pour réinitialiser l'état
    const handleReset = () => {
        setStatus('idle')
        setResponseData(null)
        setErrorMessage('')
    }

    return (
        <div className="app-container">
            <header className="app-header">
                <h1>🚀 n8n Webhook Trigger</h1>
                <p>Déclenche un workflow n8n en un clic</p>

                {/* Navigation par onglets */}
                <nav className="tabs-navigation">
                    <button
                        className={`tab-button ${activeTab === 'webhook' ? 'active' : ''}`}
                        onClick={() => setActiveTab('webhook')}
                    >
                        ⚡ Webhook Trigger
                    </button>
                    <button
                        className={`tab-button ${activeTab === 'roadmap' ? 'active' : ''}`}
                        onClick={() => setActiveTab('roadmap')}
                    >
                        🗺️ Roadmap Agent IA
                    </button>
                </nav>
            </header>

            {/* Contenu selon l'onglet actif */}
            {activeTab === 'webhook' && (
                <main className="app-main">
                    {/* Bouton principal : change selon l'état */}
                    <button
                        onClick={handleTriggerWorkflow}
                        disabled={status === 'loading'}
                        className={`trigger-button ${status}`}
                    >
                        {status === 'idle' && '▶️ Déclencher le workflow'}
                        {status === 'loading' && '⏳ En cours...'}
                        {status === 'success' && '✅ Succès !'}
                        {status === 'error' && '❌ Erreur'}
                    </button>

                    {/* Affichage conditionnel selon l'état */}
                    {status === 'loading' && (
                        <div className="status-message loading">
                            <div className="spinner"></div>
                            <p>Envoi de la requête au webhook...</p>
                        </div>
                    )}

                    {status === 'success' && responseData && (
                        <div className="status-message success">
                            <h3>✅ Workflow déclenché avec succès</h3>
                            <pre>{JSON.stringify(responseData, null, 2)}</pre>
                            <button onClick={handleReset} className="reset-button">
                                🔄 Réinitialiser
                            </button>
                        </div>
                    )}

                    {status === 'error' && (
                        <div className="status-message error">
                            <h3>❌ Erreur lors du déclenchement</h3>
                            <p>{errorMessage}</p>
                            <button onClick={handleReset} className="reset-button">
                                🔄 Réessayer
                            </button>
                        </div>
                    )}
                </main>
            )}

            {/* Onglet Roadmap Agent */}
            {activeTab === 'roadmap' && (
                <RoadmapAgent />
            )}

            <footer className="app-footer">
                <p>
                    🔗 Webhook URL : <code>{import.meta.env.VITE_N8N_WEBHOOK_URL || 'Non définie'}</code>
                </p>
            </footer>
        </div>
    )
}

export default App
